/*
 * @Author: ycm-windows hesion3d@hesion3d.com
 * @Date: 2021-04-15 18:24:37
 * @LastEditors: ycm-windows hesion3d@hesion3d.com
 * @LastEditTime: 2022-09-13 13:28:45
 * @FilePath: \logoup_portal\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueResource from 'vue-resource';

import App from './App';
import router from './router';

Vue.use(VueResource);

Vue.config.productionTip = false;

Vue.mixin({
  created() {
    let protocol = location.protocol 
    console.log('protocol'+protocol)
    this.$http.get(protocol+'//hesion3d-prod.oss-cn-beijing.aliyuncs.com/logoup/install/latest.json').then((response) => {
      const r = JSON.parse(response.bodyText);
      this.$data.version = r.version;
      this.$data.downloadUrls = r;
    }, () => {
    });
  },
  methods: {
    isChrome() {
      return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    },
    isSafari() {
      return navigator.userAgent.toLowerCase().indexOf('safari') > -1;
    },
    downloadFile(sUrl) {
      // iOS devices do not support downloading. We have to inform user about this.
      let protocol = location.protocol 
      if (protocol === 'https:' && sUrl.indexOf('http:') === 0) {
        sUrl = sUrl.replace('http:', 'https:');
      }

      if (/(iP)/g.test(navigator.userAgent)) {
        return false;
      }
      // If in Chrome or Safari - download via virtual link click
      if (this.isChrome() || this.isSafari()) {
        // Creating new link node.
        const link = document.createElement('a');
        link.href = sUrl;
        if (link.download !== undefined) {
          // Set HTML5 download attribute. This will prevent file from opening if supported.
          const fileName = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length);
          link.download = fileName;
        }
        // Dispatching click event.
        if (document.createEvent) {
          const e = document.createEvent('MouseEvents');
          e.initEvent('click', true, true);
          link.dispatchEvent(e);
          return true;
        }
      }
      // Force file download (whether supported by server).
      let t = sUrl;
      if (t.indexOf('?') === -1) {
        t += '?download';
      }
      // 如果 location.protocol 是 https，如果t前面是 http：，则修改t为https：
     
      window.open(t, '_self');
      return true;
    },
    download(platform) {
      debugger;
      if (this.downloadUrls) {
        this.downloadFile(this.getDownloadUrl(platform));
      }
      router.push({ path: '/download' });
    },
    getDownloadUrl(platform) {
      let downloadUrl = '';
      if (this.downloadUrls) {
        if (platform === 'mac') {
          downloadUrl = this.downloadUrls.download_url_macos;
        } else if (platform === 'linux') {
          downloadUrl = this.downloadUrls.download_url_linux;
        } 
        else if (platform === 'macIntel') {
          downloadUrl = this.downloadUrls.download_url_macos_x64;
        } 
        else if (platform === 'macArm64') {
          downloadUrl = this.downloadUrls.download_url_macos_arm64;
        }
        else if (platform === 'windows') {
          downloadUrl = this.downloadUrls.download_url_window;
        } if (platform === 'kirinArm') {
          downloadUrl = this.downloadUrls.download_url_kirinArm;
        } if (platform === 'kirinLoongArch') {
          downloadUrl = this.downloadUrls.download_url_kirinLoongArch;
        } if (platform === 'uosArm') {
          downloadUrl = this.downloadUrls.download_url_uosArm;
        } if (platform === 'uosLoongArch') {
          downloadUrl = this.downloadUrls.download_url_uosLoongArch;
        } 
        // else { kirinArm kirinLoongArch uosArm uosLoongArch
        //   downloadUrl = this.downloadUrls.download_url_email;
        // }
      }
      return downloadUrl;
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js